module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "FindMatch"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "Homepage row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row Logo-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('h1', [_vm._v("Finding a Mentor/Mentee")]), _vm._v(" "), _c('p', [_vm._v("Follow the below steps and find a restaurant and mentor/mentee that meet your preferences!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v("If you are a new member, please create an account with us first!")]), _vm._v(" "), _c('b-button', {
    staticClass: "button-style",
    attrs: {
      "size": "",
      "variant": "warning",
      "href": ""
    }
  }, [_vm._v("\n                    Sign-Up\n                  ")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v("Make sure that your profile is set up correctly so we know your preferences!")]), _vm._v(" "), _c('b-button', {
    staticClass: "button-style",
    attrs: {
      "size": "",
      "variant": "warning",
      "href": ""
    }
  }, [_vm._v("\n                    View Profile\n                  ")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v("Your all set up! Time to meet your partner!")]), _vm._v(" "), _c('b-button', {
    staticClass: "button-style",
    attrs: {
      "size": "lg",
      "variant": "success",
      "href": ""
    }
  }, [_vm._v("\n                    Pair!\n                  ")])], 1)]), _vm._v(" "), _c('p')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progressbar"
  }, [_c('b-progress', {
    attrs: {
      "precision": 1,
      "show-progress": "",
      "animated": ""
    },
    model: {
      value: (_vm.counter),
      callback: function($$v) {
        _vm.counter = $$v
      },
      expression: "counter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "profilesection"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('b-card', {
    staticClass: "profile hvr-grow"
  }, [_c('h5', {
    staticClass: "lunchbuddytitle"
  }, [_vm._v("Mentor")]), _vm._v(" "), _c('img', {
    staticClass: "profileimg",
    attrs: {
      "src": require("./../assets/profile_picture.png")
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h7', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v("Name")]), _vm._v("Justin Sidhu")], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h7', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v("Location")]), _vm._v("Vancouver")], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h7', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v("Diet")]), _vm._v("Vegetarian")], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "restaurant-profile hvr-grow"
  }, [_c('h6', {
    staticClass: "restauranttitle"
  }, [_vm._v("Restaurant")]), _vm._v(" "), _c('img', {
    staticClass: "restaurantprofileimg",
    attrs: {
      "src": require("./../assets/restaurant_profile.png")
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h7', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v("Name")]), _vm._v("Cactus Club")], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h7', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v("Location")]), _vm._v("Vancouver")], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h7', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_vm._v("Menu")]), _vm._v(" "), _c('b-button', {
    staticClass: "button-style",
    attrs: {
      "size": "lg",
      "variant": "link",
      "href": "https://www.cactusclubcafe.com/menus/"
    }
  }, [_vm._v("\n            See Menu!\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/PearLogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "id": "circle"
    }
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "id": "circle"
    }
  }, [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "id": "circle"
    }
  }, [_vm._v("3")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04da0f7d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/findmatch.vue
// module id = 36
// module chunks = 0